import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import parseImageUrl from "@insite/mobius/utilities/parseImageUrl";
import { COLORS } from "@tCentro/theme/design";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    background = "background",
    desktop_image = "desktop_image",
    tablet_image = "tablet_image",
    mobile_image = "mobile_image",
    backgroundColor = "backgroundColor",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.background]: "image" | "color";
        [fields.desktop_image]: string;
        [fields.tablet_image]: string;
        [fields.mobile_image]: string;
        [fields.backgroundColor]: string;
    };
}
export interface NISProductDetailsViewStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    leftColumnInnerContainer?: GridContainerProps;
    topGridItem?: GridItemProps;
    mobileTopGridItem?: GridItemProps;
    middleGridItem?: GridItemProps;
    middleGridItemHidden?: HiddenProps;
    mobileTopGridItemHidden?: HiddenProps;
    bottomGridItem?: GridItemProps;
    middleColumnGridItem?: GridItemProps;
    middleColumnGridItemHidden?: HiddenProps;
    zone?: HiddenProps;
    mobileGridItem?: GridItemProps;
    mobileGridItemHidden?: HiddenProps;
}

export const nisViewStyles: NISProductDetailsViewStyles = {
    leftColumnGridItem: {
        width: [12, 12, 5, 5, 5],
        css: css`
            direction: ltr;
            padding: 0px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        // margin-left: 30px !important;
                        // margin-top: 60px !important;
                    `,
                    css`
                        // margin-left: 30px !important;
                        // margin-top: 60px !important;
                    `,
                    css`
                        // order: 2;
                        max-width: 297px !important;
                        margin-right: 16px !important;
                    `,
                    css`
                        flex-basis: 33.1%;
                        max-width: 33.1%;
                        padding: 0px !important;
                        margin-left: 56px !important;
                        margin-top: 38px !important;
                        max-width: 447px !important;
                    `,
                    css`
                        flex-basis: 33.1%;
                        max-width: 33.1%;
                        padding: 0px !important;
                        margin-left: 56px !important;
                        margin-top: 38px !important;
                        max-width: 447px !important;
                    `,
                ])}
            @media (min-width: 1800px) {
                margin-left: 68px !important;
            }
            @media (min-width: 991px) and (max-width: 1280px) {
                margin: 0px 16px 0px 0px !important;
            }
            @media (min-width: 992px) and (max-width: 1078px) {
                max-width: 40% !important;
            }
        `,
    },
    middleGridItem: {
        width: [12, 12, 12, 0, 0],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        order: 3;
                        padding: 0px !important;
                        margin-top: 16px !important;
                    `,
                    null,
                    null,
                ])}
            @media (min-width: 991px) and (max-width: 1280px) {
                padding: 0px !important;
                margin-top: 16px !important;
            }
        `,
    },
    mobileGridItem: {
        width: [12, 12, 0, 0, 0],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0px !important;
                        div[class^="GridItemStyle"] {
                            &.fullWidthMobile {
                                padding: 0px !important;
                            }
                        }
                        margin-top: 16px !important;
                    `,
                    css`
                        padding: 0px !important;
                        div[class^="GridItemStyle"] {
                            &.fullWidthMobile {
                                padding: 0px !important;
                            }
                        }
                        margin-top: 16px !important;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    mobileGridItemHidden: {
        above: "md",
    },
    middleGridItemHidden: {
        above: "md",
        below: "md",
        css: css`
            width: 100%;
            direction: ltr;
            @media (min-width: 991px) and (max-width: 1024px) {
                display: visible !important;
            }
        `,
    },
    mobileTopGridItemHidden: {
        above: "md",
        css: css`
            width: 100%;
            direction: ltr;
        `,
    },
    rightColumnGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            :has(> div:empty) {
                                display: none;
                            }
                        `,
                        css`
                            :has(> div:empty) {
                                display: none;
                            }
                        `,
                        css`
                            padding-left: 0px;
                            order: 3;
                            // div {
                            //     display: flex;
                            //     align-items: center;
                            //     justify-content: end;
                            // }
                            :has(> div:empty) {
                                display: none;
                            }
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    topGridItem: {
        width: 12,
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            order: 1;
                        `,
                        css`
                            padding: 0px !important;
                        `,
                        css`
                            padding: 0px !important;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    mobileTopGridItem: {
        width: 12,
    },

    bottomGridItem: {
        width: 12,
        css: css`
            padding: 0px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            order: 2;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    middleColumnGridItem: {
        width: [12, 12, 7, 7, 7],
        css: css`
            margin-top: 20px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 0px !important;
                        padding-left: 16px !important;
                        margin-left: auto !important;
                        display: none;
                    `,
                    css`
                        margin-top: 0px !important;
                        padding-left: 16px !important;
                        margin-left: auto !important;
                        display: none;
                    `,
                    css`
                        padding: 0px !important;
                        margin-top: 0px !important;
                        div[class^="GridItemStyle"] {
                            padding: 0px !important;
                        }
                        flex-basis: 57.33% !important;
                        max-width: 57.33% !important;
                    `,
                    css`
                        margin-top: 16px !important;
                        margin-left: -1.3% !important;
                        // margin-left: -80px !important;
                    `,
                    css`
                        margin-top: 16px !important;
                        margin-left: -1.3% !important;
                        // margin-left: -80px !important;
                    `,
                ])}
            @media (min-width: 1800px) {
                margin-left: -1.7% !important;
            }
            @media (min-width: 991px) and (max-width: 1280px) {
                padding: 0px 0px 0px 16px !important;
                margin-left: -1.3% !important;
            }
        `,
    },
    middleColumnGridItemHidden: {
        below: "sm",
        css: css`
            width: 100%;
            direction: ltr;
            position: relative;
            padding-right: 16px;
        `,
    },
    container: {
        css: css`
            direction: ltr;
            background: ${COLORS.background.grayShade};
            div[class^="GridOffset"] {
                width: calc(100%) !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-bottom: 0px !important;
                        `,
                        css`
                            margin-bottom: 0px !important;
                        `,
                        css`
                            padding: 24px 16px;
                        `,
                        css`
                            margin-bottom: 24px;
                        `,
                        css`
                            margin-bottom: 24px;
                        `,
                    ],
                    "max",
                )}

            @media(min-width:1813px) {
                margin-bottom: 0px !important;
            }
            @media (min-width: 991px) and (max-width: 1280px) {
                padding: 24px 64px !important;
            }
        `,
    },
    zone: {
        above: "md",
        css: css`
            display: flex;
            justify-content: end;
            > div {
                display: flex;
                justify-content: end;
                align-items: center;
            }
        `,
    },
    // mobileGridItem: {
    //     width: 12,
    //     css: css`
    //         justify-content: end;
    //     `,
    // },
};
type Props = OwnProps;

const styles = nisViewStyles;

const NISProductDetailsView: React.FC<Props> = props => {
    const backgroundStyles =
        props.fields.background === "image"
            ? `background-image: url(${parseImageUrl(props.fields.desktop_image).url}) !important;
                background-size: cover;
    background-repeat: no-repeat;
               `
            : `background-color: ${props.fields.backgroundColor};`;

    const container = {
        css: css`
            direction: ltr;
            ${backgroundStyles};
            margin-bottom: 24px;
            border-bottom: 1px solid #e0dfe0 !important;
            div[class^="GridOffset"] {
                width: calc(100%) !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            margin: 0px !important;
                        `,
                        css`
                            margin: 0px !important;
                        `,
                        css`
                            margin: 0px !important;
                        `,
                        null,
                        null,
                    ])}
                @media (min-width:992px) and (max-width:1280px) {
                    margin: 0px !important;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 0px !important;
                        padding: 24px 16px;
                        background-image: url(${parseImageUrl(fields.mobile_image).url}) !important;
                    `,
                    css`
                        margin-bottom: 0px !important;
                        padding: 24px 16px;
                        background-image: url(${parseImageUrl(fields.mobile_image).url}) !important;
                    `,
                    css`
                        padding: 24px 16px;
                        margin-bottom: 0px !important;
                        background-image: url(${parseImageUrl(fields.tablet_image).url}) !important;
                    `,
                    css`
                        padding-bottom: 24px !important;
                    `,
                    css`
                        padding-bottom: 24px !important;
                    `,
                ])}

            @media (min-width: 991px) and (max-width:1024px) {
                padding: 24px 64px !important;
            }

            @media (min-width: 1813px) {
                margin-bottom: 0px !important;
            }
        `,
    };

    // Initialize screenWidth safely for SSR: default to a mobile-friendly width
    const [screenWidth, setScreenWidth] = React.useState<number>(
        typeof window !== "undefined" ? window.innerWidth : 1024
    );

    React.useEffect(() => {
        // Check if running in browser (not SSR)
        if (typeof window === "undefined") {
            return;
        }

        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        // Set initial width on mount
        setScreenWidth(window.innerWidth);

        // Add resize listener
        window.addEventListener("resize", handleResize);

        // Cleanup
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <GridContainer {...container}>
            <GridItem {...styles.leftColumnGridItem} data-test-selector="productDetails_leftColumn">
                <GridContainer {...styles.leftColumnInnerContainer}>
                    <GridItem {...styles.topGridItem}>
                        <Zone contentId={props.id} zoneName="Content0" />
                    </GridItem>
                    <GridItem {...styles.middleGridItem}>
                        <Hidden {...styles.middleGridItemHidden}>
                            <Zone contentId={props.id} zoneName="Content1" />
                        </Hidden>
                    </GridItem>
                    <GridItem {...styles.bottomGridItem}>
                        <Zone contentId={props.id} zoneName="Content2" />
                    </GridItem>
                </GridContainer>
            </GridItem>

            {screenWidth >= 767 && (
                <GridItem {...styles.middleColumnGridItem} data-test-selector="productDetails_middleColumn">
                    <Hidden below="sm">
                        <Zone contentId={props.id} zoneName="Content3" />
                    </Hidden>
                </GridItem>
            )}

            {screenWidth <= 767 && (
                <GridItem {...styles.mobileGridItem}>
                    <Hidden {...styles.mobileGridItemHidden}>
                        <Zone contentId={props.id} zoneName="Content8" />
                    </Hidden>
                </GridItem>
            )}
            <GridItem {...styles.rightColumnGridItem} data-test-selector="productDetails_rightColumn">
                <Zone contentId={props.id} zoneName="Content7" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect()(NISProductDetailsView),
    definition: {
        displayName: "NIS View",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                fieldType: "Contextual",
                name: fields.background,
                displayName: "Background",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Image", value: "image" },
                    { displayName: "Color", value: "color" },
                ],
                defaultValue: "color",
                hideEmptyOption: true,
            },
            {
                fieldType: "Contextual",
                name: fields.desktop_image,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Desktop_Image",
                isVisible: widget => widget.fields.background === "image",
            },
            {
                fieldType: "Contextual",
                name: fields.tablet_image,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Tablet_Image",
                isVisible: widget => widget.fields.background === "image",
            },
            {
                fieldType: "Contextual",
                name: fields.mobile_image,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Mobile_Image",
                isVisible: widget => widget.fields.background === "image",
            },
            {
                fieldType: "Contextual",
                name: fields.backgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Color",
                defaultValue: "#F2F2F2",
                isVisible: widget => widget.fields.background === "color",
            },
        ],
    },
};

export default widgetModule;
